import util from '../util'

let controller = 'FavorecidosHistorico'
export default Object.assign({}, util.GetCrud(controller), {
  ObterHistorico: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller, dto)
  },
  ObterDetalhes: function (codigoHistorico) {
    return util.Axios.GetAll(controller + '/Detalhes/' + codigoHistorico)
  }
})
